// @copyright  2006-2024 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/finance/charitable-contributions',
        component: () =>
            import('@/pages/[organisation]/finance/charitable-contributions.vue'),
        name: 'finance.charitable-contributions.search-charitable-contributions',
        meta: {
            loginRequired: true,
            permission: 'access.finance.charitable-contribution.search-charitable-contributions',
        },
        children: [
            {
                path: 'create',
                component: () =>
                    import('@/pages/[organisation]/finance/charitable-contributions/create.vue'),
                name: 'finance.charitable-contributions.create-charitable-contribution',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.charitable-contribution.create-draft-charitable-contribution',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/finance/charitable-contributions/[id].vue'),
                name: 'finance.charitable-contributions.view-charitable-contribution',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.charitable-contribution.view-charitable-contribution',
                },
                children: [
                    {
                        path: 'new-payment',
                        component: () =>
                            import(/* webpackChunkName: "finance.charitable-contributions" */ '@/pages/[organisation]/finance/charitable-contributions/charitable-contribution-payment/new.vue'),
                        name: 'finance.charitable-contributions.create-charitable-contribution-payment',
                        meta: {
                            loginRequired: true,
                            permission: 'access.finance.charitable-contribution-payment.create-charitable-contribution-payment',
                        },
                    },
                ],
            },
            {
                path: ':id/payments',
                component: () =>
                    import('@/pages/[organisation]/finance/charitable-contributions/[id]/payments.vue'),
                name: 'finance.charitable-contributions.search-charitable-contribution-payments',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.charitable-contribution-payment.view-charitable-contribution-payments',
                },
                children: [
                    {
                        path: ':paymentId/redo',
                        component: () =>
                            import(/* webpackChunkName: "finance.charitable-contributions" */ '@/pages/[organisation]/finance/charitable-contributions/redo-charitable-contribution-payment.vue'),
                        name: 'finance.charitable-contributions.redo-charitable-contribution-payment',
                        meta: {
                            loginRequired: true,
                            permission: 'access.finance.charitable-contribution-payment.create-charitable-contribution-payment',
                        },
                    },
                ],
            },
            {
                path: ':id/edit-draft',
                component: () =>
                    import('@/pages/[organisation]/finance/charitable-contributions/[id]/edit-draft.vue'),
                name: 'finance.charitable-contributions.update-draft-charitable-contribution',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.charitable-contribution.update-draft-charitable-contribution',
                },
            },
            {
                path: ':id/edit',
                component: () =>
                    import('@/pages/[organisation]/finance/charitable-contributions/[id]/edit.vue'),
                name: 'finance.charitable-contributions.update-charitable-contribution',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.charitable-contribution.update-charitable-contribution',
                },
            },
        ],
    },
];
